import { CreateLog } from "../helpers/helper";
import { Languages } from '../components/languages';

const BASE_URL = "/api/warehouseAPI";
const le = Languages.Warehouse.WarehouseAPIClient[Languages.selectedLanguage];

export async function postToWarehouse(action, jwtToken, data, logMessage) {
    
    try {
        CreateLog({
            level: "log",
            message: " Warehouse API caller - start",
            data: {
                type: logMessage,
                status: "Start"
            }
        });
        const response = await fetch(`${BASE_URL}/${action}`, {
            method: "POST",
            headers: {
                Authorization: 'Bearer ' + jwtToken,
                'Content-Type': "application/json"
            },
            body: JSON.stringify(data)
        });

        //#region Controllo errori

        //const responseText = await response.text();
        //let responseBody = null;
        //try {
        //    responseBody = responseText ? JSON.parse(responseText) : null;
        //} catch {
        //    responseBody = responseText;
        //}

        //console.error("HTTP STATUS:", response.status); console.error("HTTP STATUS TEXT:", response.statusText); console.error("RESPONSE BODY:", responseBody);

        //console.error(
        //    "VALIDATION ERRORS JSON:",
        //    JSON.stringify(
        //        responseBody?.errors,
        //        null,
        //        2
        //    )
        //);

        //#endregion

        if (!response.ok) {
            const error = new Error();
            error.message = `Error when try ${logMessage}`;
            error.status = response.status;
            throw error;
        }

        const result = await response.json();
        CreateLog({
            level: "log",
            message: " Warehouse API caller - Success",
            data: {
                type: logMessage,
                status: "Success"
            }
        });
        return result;
    } catch (ex) {
        CreateLog({
            level: "error",
            message: "Error in Warehouse API caller",
            data: {
                message: ex.message,
                status: ex.status,
            }
        })
        return {
            error: {
                message: le.error.somethingGoesWrong,
                status: ex.status
            }
        }
    }
}